<div class="popup-trigger-container" [class.popup-disabled]="control.disabled || disabled" #triggerContainer
	 [matMenuTriggerFor]="popupMenu">
	<ng-content select="[popup-trigger], app-popup-trigger"></ng-content>
</div>
<mat-menu
	#popupMenu
	(click)="$event.stopPropagation()"
	(closed)="onClose()"
	xPosition="after" yPosition="below"
	class="mat-menu-custom-popup">
	<div (click)="$event.stopPropagation()" class="flex-column gap-S pad-S">
		<div (click)="$event.stopPropagation()" class="input-with-delete flex-align-center pad-S"
			 [class.input-error]="control.invalid"
			 [class.input-warning]="warning">
			<input (click)="$event.stopPropagation()" [placeholder]="'input.inputAValue' | translate"
				   (keydown.enter)="onConfirm()" class="input-no-style h-100" type="text" [formControl]="control"
				   [class.text-red]="control.invalid"
					[class.warning]="warning">
			<div (click)="$event.stopPropagation()" class="flex-align-center flex-justify-end p-absolute"
				 style="right: 16px">
				<button class="add-insert-btn flex-center"
						[class.c-p]="control.valid"
						[class.c-na]="control.invalid"
						[disabled]="control.invalid"
						(click)="onConfirm()">
					<img src="assets/icons/arrow-right-2.svg"
						 class="filter-white">
				</button>
			</div>
		</div>
		<div @validators-appear *ngIf="control.errors" class="danger font-M">
			<span *ngIf="control.errors?.['ipAddress']">{{ 'page.infrastructure.overview.ipAddressValidator' | translate }}</span>
		</div>
		<div @validators-appear *ngIf="warning" class="warning font-M">
			<span *ngIf="warning">{{ warning }}</span>
		</div>
	</div>
</mat-menu>
